import { useState, ReactNode, FC } from 'react';
import cn from 'classnames';
import CaretDown from '../icons/general/CaretDown/CaretDown';

import cls from './style.module.scss';

type UniversalAccordionProps = {
	title: string;
	accordionContent: ReactNode;
	rightContentLine1?: string;
	rightContentLine2?: string;
	isNegative?: boolean;
	caretPosition?: 'left' | 'right';

	// Классы для кастомизации
	className?: string;
	headerClassName?: string;
	titleClassName?: string;
	caretClassName?: string;
	contentClassName?: string;
	rightContentClassName?: string;
	rightLine1ClassName?: string;
	rightLine2ClassName?: string;

	// Каретка
	caretColor?: string | undefined;
	caretWidth?: number | string;
	caretHeight?: number | string;
};

const UniversalAccordion: FC<UniversalAccordionProps> = ({
	title,
	accordionContent,
	rightContentLine1,
	rightContentLine2,
	isNegative,
	caretPosition = 'left',

	// Классы
	className,
	headerClassName,
	titleClassName,
	caretClassName,
	contentClassName,
	rightContentClassName,
	rightLine1ClassName,
	rightLine2ClassName,

	// Каретка
	caretColor,
	caretWidth = 12,
	caretHeight = 7,
}) => {
	const [isOpen, setIsOpen] = useState(false);

	const toggleAccordion = () => {
		setIsOpen(!isOpen);
	};

	return (
		<div className={cn(cls.accordion, className)}>
			<div className={cn(cls.accordionHeader, headerClassName)} onClick={toggleAccordion}>
				{caretPosition === 'left' && (
					<span
						className={cn(cls.accordionToggleIcon, cls.caretLeft, caretClassName, {
							[cls.rotate]: isOpen,
						})}
					>
						<CaretDown color={caretColor} width={caretWidth} height={caretHeight} />
					</span>
				)}

				<h3 className={cn(cls.accordionTitle, titleClassName)}>{title}</h3>

				{rightContentLine1 && rightContentLine2 && (
					<div className={cn(cls.accordionRightContent, rightContentClassName)}>
						<div className={cn(cls.accordionRightLine1, rightLine1ClassName)}>{rightContentLine1}:</div>
						<div
							className={cn(
								cls.accordionRightLine2,
								{
									[cls.negative]: isNegative,
								},
								rightLine2ClassName,
							)}
						>
							{rightContentLine2}
						</div>
					</div>
				)}

				{caretPosition === 'right' && (
					<span
						className={cn(cls.accordionToggleIcon, cls.caretRight, caretClassName, {
							[cls.rotate]: isOpen,
						})}
					>
						<CaretDown color={caretColor} width={caretWidth} height={caretHeight} />
					</span>
				)}
			</div>
			{isOpen && <div className={cn(cls.accordionContent, contentClassName)}>{accordionContent}</div>}
		</div>
	);
};

export default UniversalAccordion;
